module.exports = __webpack_public_path__ + "static/media/biurka_warszawa_c.ab7cb3c3.png";